export default "__VITE_ASSET__$i2i9Ty3__"